import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const pageTitles = {
  '/': 'Dashboard',
  '/dashboard': 'Dashboard',
  '/pipeline': 'Pipeline',
  '/candidates': 'Candidates',
  '/talent-pool': 'Talent Pool',
  '/assessments': 'Assessments',
  '/settings': 'Settings',
  '/users': 'User Management',
  '/email-templates': 'Email Templates',
  '/career-settings': 'Career Page',
  '/help': 'Help / Manuals',
  '/roles': 'Roles & Permissions',
  '/import': 'Import Candidates',
};

function pageTitleFromPath(pathname) {
  const p = pathname.startsWith('/admin') ? pathname.slice(6) || '/' : pathname;
  if (/^\/candidates\/.+/.test(p)) return 'Candidate Detail';
  const first = p.replace(/^\/+/, '').split('/')[0];
  const base = first ? `/${first}` : '/';
  if (pageTitles[base]) return pageTitles[base];
  return 'Dashboard';
}

export default function AppLayout() {
  const { pathname } = useLocation();
  const title = pageTitleFromPath(pathname);
  const [navOpen, setNavOpen] = useState(false);

  // Navigating from the drawer should not leave it covering the new page.
  useEffect(() => { setNavOpen(false); }, [pathname]);

  return (
    <div className="min-h-screen surface-base">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-toast focus:rounded-xl focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-brand-700 focus:shadow-lg focus:ring-2 focus:ring-brand-500"
      >
        Skip to main content
      </a>

      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />

      {navOpen && (
        <div
          className="fixed inset-0 z-backdrop bg-black/50 lg:hidden"
          onClick={() => setNavOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="lg:ml-72">
        <Header title={title} navOpen={navOpen} onOpenNav={() => setNavOpen(true)} />
        <main id="main-content" tabIndex={-1} className="p-6 lg:p-8 outline-none">
          <div className="max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
